export type PackageCategoryCreateFormValue = {
  code: string
  name: string
  shortName: string
  enable: boolean
}

export const initialPackageCategoryCreateFormValue: PackageCategoryCreateFormValue =
  {
    code: '',
    name: '',
    shortName: '',
    enable: true
  }
